import React, { useState, useEffect } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import MenuAdministrativos from './MenuAdministrativos';
import ButtonsMenu from '../../Utils/ButtonsMenu';
import { useAuth } from '../../../Auth/AuthContext';

export default function InformeRemisiones(){
    const navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const { token } = useAuth();
    const [datosRemisiones, setDatosRemisiones] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10); 
    const [swalProps, setSwalProps] = useState();
    useEffect(() => {
        fetchData(currentPage, perPage);
    }, []);
    const fetchData = async (page, rowsPerPage) => {
        let url = `/caracterizacion/diagnosticos/listardatoremisiones?page=${page}&limit=${rowsPerPage}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setDatosRemisiones(result.data);
            setTotalRows(result.meta.total);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    const columns = [
        {
            name: 'Acciones',
            cell: row => (
            <div>
                <button onClick={() => verAtencionesPersona(row)} 
                        style={{backgroundColor: 'skyblue'}} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Ver atenciones de la persona">
                <i className="fas fa-list nav-icon"></i>
                </button>
                
            </div>
            ),
            ignoreRowClick: true,
            width: '3%'
        },
        { name: 'Identificación', selector: row => row.per_idpersona, sortable: true, width:'11%' },
        { name: 'Nombre', selector: row => row.nombre, sortable: true, width: '20%'},
        { name: '¿La unidad de negocio está cargo de una persona que no es el jefe o jefa de hogar?', selector: row => row.aut_personaacargo, sortable: true, width: '15%'},
        { name: 'Nombre encargado/a del negocio', selector: row => row.aut_nombreencargado, sortable: true, width: '10%'},
        { name: 'No. De la cédula de ciudadanía', selector: row => row.aut_cedula, sortable: true, width: '10%'},
        { name: 'Sexo', selector: row => row.aut_sexo, sortable: true, width: '10%'},
        { name: 'Fecha de nacimiento', selector: row => row.aut_fechanacimiento, sortable: true, width: '10%'},
        { name: 'Zona,', selector: row => row.tip_tipozona, sortable: true, width: '10%'},
        { name: 'Nombre zona', selector: row => row.aut_nombrezona, sortable: true, width: '10%'},
        { name: 'Tipo de entorno', selector: row => row.tip_tipoentorno, sortable: true, width: '10%'},
        { name: 'Nombre tipo de entorno', selector: row => row.aut_nombretipoentorno, sortable: true, width: '10%'},
        { name: 'Dirección', selector: row => row.aut_direccion, sortable: true, width: '10%'},
        { name: 'Teléfono 1', selector: row => row.aut_telefono1, sortable: true, width: '10%'},
        { name: 'Teléfono 2', selector: row => row.aut_telefono2, sortable: true, width: '10%'},
        { name: 'Celular', selector: row => row.aut_celular, sortable: true, width: '10%'},
        { name: 'Relación con el jefe del hogar', selector: row => row.par_parentesco, sortable: true, width: '10%'},
        { name: 'Incluido/a en la declaracion', selector: row => row.aut_incluidodeclaracion, sortable: true, width: '10%'},
        { name: 'Nombre del negocio', selector: row => row.aut_nombrenegocio, sortable: true, width: '10%'},
        { name: 'Tiempo de funcionamiento', selector: row => row.aut_tiempofuncionamiento, sortable: true, width: '10%'},
        { name: 'Actividad economica (descripción)', selector: row => row.aut_actividadeconomica, sortable: true, width: '10%'},
        { name: 'Sector económico', selector: row => row.sec_sector, sortable: true, width: '10%'},
        { name: 'Donde funciona negocio', selector: row => row.don_dondefunciona, sortable: true, width: '10%'},
        { name: 'Dirección/ubicacion del negocio si es diferente a casa', selector: row => row.aut_direccionnegocio, sortable: true, width: '10%'},
        { name: 'Recibio apoyo de generación de ingresos por parte de gobierno local o nacional', selector: row => row.aut_recibioapoyo, sortable: true, width: '10%'},
        { name: 'Entidad/programa', selector: row => row.aut_entidadprograma, sortable: true, width: '10%'},
        { name: 'Año', selector: row => row.aut_ano, sortable: true, width: '10%'},
        { name: 'Cuanto recibió', selector: row => row.aut_cuantorecibio, sortable: true, width: '10%'},
        { name: 'Cuenta con espacio y distribución adecuada', selector: row => row.aut_cuentaespacio, sortable: true, width: '10%'},
        { name: 'Tiene RUT', selector: row => row.aut_tienerut, sortable: true, width: '10%'},
        { name: 'Tiene manipulación de alimentos', selector: row => row.aut_tienemanipualime, sortable: true, width: '10%'},
        { name: 'Tiene bioseguridad', selector: row => row.aut_tienebioseguridad, sortable: true, width: '10%'},
        { name: 'Tiene permiso de espacio publico', selector: row => row.aut_tienepermiesppublico, sortable: true, width: '10%'},
        { name: 'Total valor de activos', selector: row => row.aut_totalactivos, sortable: true, width: '10%'},
        { name: 'Necesidades otros activos', selector: row => row.aut_necesidadesotrosactivos, sortable: true, width: '10%'},
        { name: 'Lleva registros contables', selector: row => row.aut_llevaregcontables, sortable: true, width: '10%'},
        { name: 'Promedio ventas mensuales', selector: row => row.aut_promventasmensual, sortable: true, width: '10%'},
        { name: 'Promedio gastos totales mensuales (negocio)', selector: row => row.aut_promgastostotalmen, sortable: true, width: '10%'},
        { name: 'En que invierte las ganancias', selector: row => row.tip_tipoinversion, sortable: true, width: '10%'},
        { name: 'Tiene o ha tenido crédito para su negocio', selector: row => row.aut_tienecredito, sortable: true, width: '10%'},
        { name: 'Si tiene o ha tenido crédito donde?', selector: row => row.aut_entidadcredito, sortable: true, width: '10%'},
        { name: 'Si no tiene crédito porque', selector: row => row.not_notienecredito, sortable: true, width: '10%'},
        { name: 'Tiene adecuado manejo productivo', selector: row => row.aut_manejoadeproduc, sortable: true, width: '10%'},
        { name: 'Maneja criterios ténicos de producción', selector: row => row.aut_criteriotecnicoprod, sortable: true, width: '10%'},
        { name: 'Maneja criterios de calidad', selector: row => row.aut_criteriocalidad, sortable: true, width: '10%'},
        { name: 'Identifica y realiza correctivos a problemas del proceso productivo', selector: row => row.aut_correctivosproblema, sortable: true, width: '10%'},
        { name: 'Tiene fácil acceso a sus proveedores', selector: row => row.aut_facilaccesoproveedores, sortable: true, width: '10%'},
        { name: 'Se ha diversificado o mejorado sus productos', selector: row => row.aut_diversificadoproductos, sortable: true, width: '10%'},
        { name: 'Quiere implementar nuevos productos', selector: row => row.aut_quiereimplenuevoprod, sortable: true, width: '10%'},
        { name: 'Conoce las características de su clientela', selector: row => row.aut_conocecaracclientela, sortable: true, width: '10%'},
        { name: 'Conoce las características de su competencia', selector: row => row.aut_conocecaraccompe, sortable: true, width: '10%'},
        { name: 'Horario capacitación', selector: row => row.hor_horariocapacitacion, sortable: true, width: '10%'},
        { name: 'Continúa en proceso AE', selector: row => row.aut_continuaproceso, sortable: true, width: '10%'},
        { name: 'Razón porque no continiúa en proceso AE', selector: row => row.aut_porquenocontinuaproceso, sortable: true, width: '10%'}
    ];
    function verAtencionesPersona (row){
        navigate(`/consulta/consultaatenciones/${row.per_idpersona}`);
    };
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
        fetchData(page, newPerPage);
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage);
      };

    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Informe caracterizaci&oacute;n remisiones</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to="/caracterizacion/informesadministrativos" > Administrativos</NavLink></li>
                        <li className="breadcrumb-item active"> Remisiones</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuAdministrativos></MenuAdministrativos>
                    <div className="row">
                        <div className="col-md-12">
                            <ButtonsMenu data={datosRemisiones}></ButtonsMenu>
                            <div className="card-body table-responsive p-0">
                                <DataTable
                                    title="Remisiones"
                                    columns={columns}
                                    data={datosRemisiones}
                                    progressPending={Cargando}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationPerPage={perPage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}